import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { ICON } from 'resources/constants';
import { useText } from 'common/hooks';

import Form from './Form';
import Thanks from './Thanks';
import { Modal, CloseIcon, Container, Text, HorizontalRuler } from './elements';

const deps = {
  feedbackSent: state.challenge.info.feedbackSent,
  dismissNps: sequences`challenge.info.dismissNps`,
};

export function NpsModal({
  feedbackSent,
  dismissNps,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Modal onHide={() => dismissNps} show>
      <CloseIcon icon={ICON.close} onClick={() => dismissNps()} />
      <Container>
        <Text>{t('challenge.NpsModal.feedback_matters')}</Text>
        <HorizontalRuler />
        {feedbackSent ? <Thanks /> : <Form />}
      </Container>
    </Modal>
  );
}

export default connect(deps, NpsModal);
